export default __webpack_public_path__ + "static/media/400.69d8eaf0.png";